import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../ui/Button/Button";
import { partIsStaggered } from "../Filters/TireSizeFilters/partIsStaggered";
import { useStockLevelsModal } from "../StockLevelsModal/StockLevelsModal";
import { ModifiedTirePartItem } from "../useTireResults";

type StockLevelsProps = {
  part: ModifiedTirePartItem;
};

export const StockLevels: FunctionComponent<StockLevelsProps> = ({ part }) => {
  const isStaggered = partIsStaggered(part);
  const { t } = useTranslation();
  const [, setPartId] = useStockLevelsModal();
  return (
    <div className="px-4 md:px-8 text-sm text-ink-2 font-thin flex items-center">
      <span className="mr-auto">{t("searchResults.nationalStock")}:</span>
      <Button
        onClick={(): void => {
          setPartId(part.partDetails.primaryPart.itemId);
        }}
        aria-label="checkNationalStock"
        className="py-4 rounded-none"
      >
        {t(
          isStaggered
            ? "searchResults.checkNationalStockFront"
            : "searchResults.checkNationalStock"
        )}
      </Button>
      {isStaggered && (
        <Button
          onClick={(): void => {
            setPartId(part.partDetails.secondaryParts[0].itemId);
          }}
          aria-label="checkNationalStockRear"
          className="py-4 rounded-none"
        >
          {t("searchResults.checkNationalStockRear")}
        </Button>
      )}
    </div>
  );
};
